import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-master-settings-renderer',
    templateUrl: './master-settings-renderer.component.html',
    styleUrls: ['./master-settings-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class MasterSettingsRendererComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }

}
